var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("woot-reports", {
    key: "agent-reports",
    attrs: {
      type: "agent",
      "getter-key": "agents/getAgents",
      "action-key": "agents/get",
      "download-button-label": _vm.$t("REPORT.DOWNLOAD_AGENT_REPORTS")
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }